var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import OkCancelModal from '@/shared/components/OkCancelModal';
import Checkbox from '@/shared/components/input/Checkbox';
var messages = defineMessages({
    RecognitionOptions: {
        id: 'RecognitionOptions',
        defaultMessage: 'RecognitionOptions',
    },
    LinkEmailsToCustomer: {
        id: 'LinkEmailsToCustomer',
        defaultMessage: 'Link emails to relations of type customer',
    },
    LinkEmailsToOther: {
        id: 'LinkEmailsToOther',
        defaultMessage: 'Link emails to relations of type other',
    },
    LinkEmailsToProspect: {
        id: 'LinkEmailsToProspect',
        defaultMessage: 'Link emails to relations of type prospect',
    },
    LinkEmailsToOwnCompany: {
        id: 'LinkEmailsToOwnCompany',
        defaultMessage: 'Link emails to relations of type own company',
    },
    AllowedSendersDescription: {
        id: 'AllowedSendersDescription',
        defaultMessage: 'By default, only attachments of e-mails sent by one of the employees to the magic-mail address will be recognized. Click the add button below to add custom e-mail senders for which document recognition should also be performed on attachments.',
    },
    EmailPlaceholder: {
        id: 'Email',
        defaultMessage: 'Email',
    },
    Add: {
        id: 'Add',
        defaultMessage: 'Add',
    },
    RemoveEmailAddress: {
        id: 'RemoveEmailAddress',
        defaultMessage: 'Remove e-mail address',
    },
});
var RecognitionOptionsModal = function (_a) {
    var show = _a.show, onClose = _a.onClose, onSave = _a.onSave, magicMailAllowedAttachmentSenders = _a.magicMailAllowedAttachmentSenders, linkEmailToCrmOther = _a.linkEmailToCrmOther, linkEmailToCrmProspect = _a.linkEmailToCrmProspect, linkEmailToCrmOwnCompany = _a.linkEmailToCrmOwnCompany;
    var intl = useIntl();
    var _b = useState(function () {
        return magicMailAllowedAttachmentSenders ? magicMailAllowedAttachmentSenders.split(';') : [];
    }), emailSenders = _b[0], setEmailSenders = _b[1];
    var _c = useState(linkEmailToCrmOther), crmOther = _c[0], setCrmOther = _c[1];
    var _d = useState(linkEmailToCrmProspect), crmProspect = _d[0], setCrmProspect = _d[1];
    var _e = useState(linkEmailToCrmOwnCompany), crmOwnCompany = _e[0], setCrmOwnCompany = _e[1];
    var handleSave = function () {
        onSave({
            magicMailAllowedAttachmentSenders: emailSenders.length === 0 ? '' : emailSenders.join(';'),
            linkEmailToCrmOther: crmOther,
            linkEmailToCrmProspect: crmProspect,
            linkEmailToCrmOwnCompany: crmOwnCompany,
        });
    };
    var addEmail = function () {
        setEmailSenders(function (prev) { return __spreadArray(__spreadArray([], prev, true), [''], false); });
    };
    var removeEmail = function (index) {
        setEmailSenders(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    var updateEmail = function (index, value) {
        setEmailSenders(function (prev) { return prev.map(function (email, i) { return (i === index ? value : email); }); });
    };
    return (_jsx(OkCancelModal, __assign({ title: intl.formatMessage(messages.RecognitionOptions), show: show, onClose: onClose, onSave: handleSave, disableFullScreen: true }, { children: _jsxs("div", __assign({ className: "form-horizontal", role: "form" }, { children: [_jsx("div", __assign({ className: "margin10B" }, { children: _jsx("div", __assign({ className: "form-group" }, { children: _jsxs("div", __assign({ className: "col-sm-12" }, { children: [_jsx("div", { children: _jsx(Checkbox, { value: true, disabled: true, onClick: function () { }, text: intl.formatMessage(messages.LinkEmailsToCustomer) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmOther, onClick: function (v) { return setCrmOther(v); }, text: intl.formatMessage(messages.LinkEmailsToOther) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmProspect, onClick: function (v) { return setCrmProspect(v); }, text: intl.formatMessage(messages.LinkEmailsToProspect) }) }), _jsx("div", { children: _jsx(Checkbox, { value: crmOwnCompany, onClick: function (v) { return setCrmOwnCompany(v); }, text: intl.formatMessage(messages.LinkEmailsToOwnCompany) }) })] })) })) })), _jsx("div", __assign({ className: "margin10B" }, { children: intl.formatMessage(messages.AllowedSendersDescription) })), _jsx("div", __assign({ className: "form-group" }, { children: _jsxs("div", __assign({ className: "col-sm-12" }, { children: [emailSenders.map(function (email, index) { return (_jsxs("div", __assign({ className: "row margin10B" }, { children: [_jsx("div", __assign({ className: "col-sm-11" }, { children: _jsx("input", { type: "text", placeholder: intl.formatMessage(messages.EmailPlaceholder), className: "form-control", value: email, onChange: function (e) { return updateEmail(index, e.target.value); } }) })), _jsx("div", __assign({ className: "col-sm-1" }, { children: _jsx("a", __assign({ onClick: function () { return removeEmail(index); }, style: { verticalAlign: 'sub' }, title: intl.formatMessage(messages.RemoveEmailAddress), className: "clickable" }, { children: _jsx("i", { className: "fa fa-remove" }) })) }))] }), index)); }), _jsx("div", { children: _jsxs("a", __assign({ onClick: addEmail, title: intl.formatMessage(messages.Add), className: "btn btn-default btn-xs" }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", __assign({ className: "margin5L" }, { children: intl.formatMessage(messages.Add) }))] })) })] })) }))] })) })));
};
export default RecognitionOptionsModal;
